import React, { useState } from 'react';
import {
  Button,
  Grid,
  Tooltip,
  Typography,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CommonDialog from 'components/commonDialog/CommonDialog';
import CommonModal from 'components/commonModal/CommonModal';
import { dateFormate } from 'utils/utils';
import pdfImg from 'assets/images/pdfImg.svg';
import download from 'assets/images/download.png';


function ComplianceDocumentDetails(props) {
  const [open, setOpen] = useState(false);
  const [previewModal, setPreviewModal] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const details = props?.details.length > 0 ? props?.details : [];
  const [selectedDocs, setSelectedDocs] = useState([])
  const [selectedImage,setSelectedImage] = useState('');
  const [selected, setSelected] = useState(false)
  
  const handleCheckboxChange = (index, name) => {
    let newArray = [];
    let newObject = {
      placeholder: "Reject Reason",
      required: true,
      type: "textarea",
      name: "",
      label: "",
      multiline: true,
      row: 7,
    };
    newArray = selectedDocs;
    const idx = newArray.findIndex((data) => data.id == index);
    if (idx > -1) {
      newArray.splice(idx, 1);
      if (newArray?.length > 0) {
        setSelected(true);
      } else {
        setSelected(false);
      }
      setSelectedDocs(newArray);
    } else {
      newObject = {
        ...newObject,
        id: index,
        name: index,
        label: "Reject Reason(" + name + ")",
      };
      newArray.push(newObject);
      setSelected(true);
      setSelectedDocs(newArray);
    }
  };
  const handleRejectedButtonClick = (val) => {
    setOpen(true);
  };
  const handleApprovalButtonClick = (val) => {
    props?.onClickVerification(selectedDocs, val);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };
  const handleClose = () =>{
    setSelectedImage(null);
    setPreviewModal(false);
  }
  const handleOpen = (image) =>{
    setSelectedImage(image);
    setPreviewModal(true); 
  }
  const onDialog = (data) => {
    const val = data;
    handleApprovalButtonClick(val);
    setOpen(false);
  };

  const handleOnError = (e) => {
    e.target.src = pdfImg;
  };

  const filteredFiles = details?.filter((val) => val.attributeType === "File");
  const filteredImages = details?.filter(
    (val) =>
      val.attributeType === "Image" || val.attributeType === "Multi-Image"
  );
  const filteredTextDocuments = details?.filter(
    (val) => val.attributeType === "text"
  );

  const role = localStorage.getItem('role')

  const renderDocument = (document) => {
    const isDisabled =
      document?.status === "Approved" ||
      document?.status === "Rejected" ||
      document?.isExpired === true;
    return (
      <Grid
        item
        md={3.7}
        sm={12}
        className="borderStyle padding10 m10"
        key={document.id}
        onClick={(e) =>{
          if (e.target.tagName.toLowerCase() !== 'input') {
           (document?.attributeType !== 'text' && 
           !document?.complianceFile?.name.includes('.pdf'))&& handleOpen(document?.complianceFile?.url)
          }
        }}
      >
        <div className="dlImgMain">
          <div className="dlImgBg"></div>
          <FormGroup className="formGrp">
            <FormControlLabel
              value="bottom"
              className="checkbox"
              control={
                role !== 'subVendorCompany' ?
                <Checkbox
                  className={`checkBoxAlign ${
                    document?.status === "Approved" ||
                    document?.status === "Rejected" ||
                    document?.isExpired === true
                      ? "checkBoxColor"
                      : ""
                  }`}
                  onChange={() =>
                    handleCheckboxChange(document?.id, document?.complianceName)
                  }
                  disabled={isDisabled}
                />: <></>
              }
              label={
              <div>
                  {document?.attributeType !== "text" ? (
                    <img
                      src={
                        document?.complianceFile?.name.includes(".pdf") &&
                        document?.complianceFile?.url
                          ? pdfImg
                          : document?.complianceFile?.url
                      }
                      alt="driving"
                      className="dlImg"
                      onError={handleOnError}
                    />
                  ) : null}
                </div>
              }
            />
          </FormGroup>
        </div>
        <Grid
          item
          container
          direction="row"
          justifyContent="space-between"
          alignItems={document?.attributeType === "text" && "center" }
          className={`padding10 height110 ${
            document?.attributeType === "text" ? "backgroundGrey" : null
          }`}
        >
          <Grid item>
            <h1 className="colorBlack font14 fontMedium textOverflow">
              {document?.complianceName}
              {document?.isMandatory && <span className="colorRed">*</span>}
            </h1>
            {document?.atributeValue && (
              <p className="font12 fontNormal colorGrey">
                Number: {document?.atributeValue}
              </p>
            )}
            {document?.expiryDate && (
              <p className="font12 fontNormal colorBlue">
                <span className="colorBlue">Exp: </span>
                {dateFormate(document?.expiryDate, "DD MMMM YYYY")}
              </p>
            )}
          </Grid>
          <Grid item>
            {document?.attributeType === "text" ? (
              ""
            ) : (
              <div className="colorGrey textCenter marginTop mb10">
                {document?.complianceFile?.size}
                <span className="marginInline10">
                  <a
                    href={document?.complianceFile?.url}
                    download={document?.complianceFile?.name}
                  >
                    <img src={download} alt="download icon" />
                  </a>
                </span>
              </div>
            )}
            {document?.status && document?.isExpired !== true && (
              <Tooltip title={document?.rejectionReason}>
                <Typography
                  className={` ${
                    document?.status + "Btn"
                  } flexDirection cursorDefault`}
                >
                  {document.status === "Rejected" && (
                    <ErrorOutlineIcon className="marginRight3 font16" />
                  )}
                  {document?.status}
                </Typography>
              </Tooltip>
            )}

            {document?.isExpired === true && (
              <Typography className=" colorRed flexDirection cursorDefault">
                Expired
              </Typography>
            )}
          </Grid>
        </Grid>
      </Grid>
    );
  };

  return (
    <div>
      {filteredFiles?.length > 0 && (
        <Typography className="mb20 padding10 font18">
          Text With File Documents
        </Typography>
      )}
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="start"
      >
        {details?.map((document, idx) => {
          if (document?.attributeType === "File") {
            return renderDocument(document);
          }
          return null;
        })}
      </Grid>

      {filteredFiles?.length > 0 && <div className="dashedborder"></div>}

      {/* ---Text View--- */}
      {filteredTextDocuments?.length > 0 && (
        <Typography className="mb20 padding10 font18">
          Text Documents
        </Typography>
      )}
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="start"
      >
        {details?.map((document, idx) => {
          if (document?.attributeType === "text") {
            return renderDocument(document);
          }
          return null;
        })}
      </Grid>

      {/* ---Image Section--- */}
      {filteredTextDocuments?.length > 0 && (
        <div className="dashedborder"></div>
      )}
      {filteredImages?.length > 0 && (
        <Typography className="mb20 padding10 font18">
          Text With Multi-Image
        </Typography>
      )}
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="start"
      >
        {details?.map((document, idx) => {
          if (
            document?.attributeType === "Image" ||
            document?.attributeType === "Multi-Image"
          ) {
            return renderDocument(document);
          }
          return null;
        })}
      </Grid>

      {role !== 'subVendorCompany' && <Grid
        container
        justifyContent="flex-end"
        direction="row"
        Spacing={2}
        className="buttonColor"
      >
        {details?.length > 0 && (
          <Grid item Spacing={2}>
            <Button
              className="buttonRed"
              variant="contained"
              disabled={selected ? false : true}
              onClick={() => handleRejectedButtonClick("rejcted")}
            >
              Reject
            </Button>
          </Grid>
        )}

        {details?.length > 0 && (
          <Grid item>
            <Button
              className="buttonGreen"
              variant="contained"
              disabled={selected ? false : true}
              onClick={() => handleApprovalButtonClick({ status: "accepted" })}
            >
              Approve
            </Button>
          </Grid>
        )}
      </Grid> }
    {previewModal && <CommonModal
        open={previewModal}
        handleClose={handleClose}
        selectedImage={selectedImage}
    />
       } 
      {open && <CommonDialog className='marginbottom20'
        open={open}
        handleClose={() => setOpen(false)}
        formData={selectedDocs}
        button={'dialogButton'}
        onSubmittBtn={onDialog}
        selectType={'Send'}
      />}


      {isModalOpen && (
        <CommonDialog
          open={isModalOpen}
          button={"dialogButton"}
          handleClose={handleModalClose}
        />
      )}
    </div>
  );
}

export default ComplianceDocumentDetails;
